/* Action Types */
export const LOAD_CATALOGS_FAIL = 'la/domain/catalogs/LOAD_FAIL';
export const LOAD_CATALOGS_REQUEST = 'la/domain/catalogs/LOAD_REQUEST';
export const LOAD_CATALOGS_SUCCESS = 'la/domain/catalogs/LOAD_SUCCESS';
